import { ref, onMounted } from '@vue/composition-api'
import usersApi from '@/services/api/users'

export default function useCurrentUser() {
  const user = ref(null)

  onMounted(async () => {
    try {
      const res = await usersApi.me()
      user.value = res.data.data
    } catch (_) {
      // non-critical
    }
  })

  return { user }
}



// WEBPACK FOOTER //
// ./src/composables/useCurrentUser.js